/**
 * Return true if the user is a billing admin for at least one "GoToMeeting" product
 */
define('lib/models/account/check-billing-admin',[],function () {
    return function (products, userKey) {
        return products
            .filter(function (product) {
                return product.product === 'GoToMeeting';
            })
            .some(function (product) {
                return product.billingAdminUserKey === userKey;
            });
    };
});

